import React from 'react';
import { motion } from 'framer-motion';
export function IdentityTransitionSection() {
  return <section className="bg-gradient-section px-5 md:px-8" data-id="element-345" data-mp="135h1rvor7j66">
      <div className="mx-auto max-w-2xl" data-id="element-346" data-mp="133w5o1msjs67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.9,
        delay: 0.2
      }} className="mt-20 md:mt-28 max-w-md mx-auto text-center" data-id="element-347" data-mp="y6cq8yecx9co">
          <p className="font-display italic text-[#F0E8D8]/65 leading-[1.5]" style={{
          fontSize: "19px"
        }} data-id="element-348" data-mp="keg3zazddto7">
            “Lo que antes funcionaba,<br data-id="element-349" data-mp="fe1t7l6dw5mh" />hoy ya no alcanza.”
          </p>

          <div className="flex flex-col items-center my-7 gap-0.5" data-id="element-350" data-mp="aicqxa2zcamh">
            <div className="w-px" style={{
            height: 28,
            background: 'linear-gradient(to bottom, rgba(200,168,112,0.15), rgba(200,168,112,0.55))',
            boxShadow: '0 0 8px rgba(200,168,112,0.25)'
          }} data-id="element-351" data-mp="6fgfc3buxes1" />
            <span className="text-[#C8A870]" style={{
            fontSize: 18,
            lineHeight: 1,
            textShadow: '0 0 12px rgba(200,168,112,0.35)'
          }} data-id="element-352" data-mp="cp8qxeq8a8cb">↓</span>
          </div>

          <p className="font-display font-semibold text-[#F0E8D8] leading-[1.2] mb-4" style={{
          fontSize: 'clamp(24px, 5.5vw, 36px)'
        }} data-id="element-353" data-mp="3qx13ex6rekx">
            No se trata de volver atrás.
          </p>
          <p className="font-display italic text-gradient-gold leading-[1.25]" style={{
          fontSize: 'clamp(20px, 5vw, 32px)'
        }} data-id="element-354" data-mp="vhb8csap1snm">
            Se trata de aprender<br data-id="element-355" data-mp="mgmx25coq6ef" />qué necesita tu cuerpo hoy.
          </p>

          <div className="mx-auto mt-10 mb-7" style={{
          width: 48,
          height: '0.5px',
          background: 'rgba(200,168,112,0.35)'
        }} data-id="element-356" data-mp="mi6e3y660lh9" />
        </motion.div>
      </div>
    </section>;
}